module.exports = __webpack_public_path__ + "static/media/resend.1a674a81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/resend.svg
// module id = 1497
// module chunks = 0